import { render, staticRenderFns } from "./firmwareTest.vue?vue&type=template&id=12a38214&scoped=true"
import script from "./firmwareTest.vue?vue&type=script&lang=js"
export * from "./firmwareTest.vue?vue&type=script&lang=js"
import style0 from "./firmwareTest.vue?vue&type=style&index=0&id=12a38214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a38214",
  null
  
)

export default component.exports